<template>
    <div v-if="showModal">
        <div class="special-overlay"></div>
        <div class="modal" style="display: block;">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div style="float: right;">
                        <button type="button" @click="closeModal" class="close text-right mr-4 mt-3" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" style="font-size: 20px;">&times;</span>
                        </button>
                    </div>
                    <!-- <h2 class="modern text-center mb-0">Menu Schedule<br>Changes!<br></h2> -->
                    <h2 class="modern text-center mb-0">Kosmos x Gelati dimani<br></h2>
                    <div class="modal-body">
                        <div class="row border-top">
                            <div class="col-lg-1"></div>
                            <div class="col-lg-10 mt-4">

                                <h5 class="text-center mt-3a">
                                    fresh gelato made daily
                                    <br>
                                    <!-- <a target="_blank" href="https://www.opentable.com/r/kosmos-reservations-walpole?restref=1239994&lang=en-US&ot_source=Restaurant%20website">Make your reservation today!</a> -->
                                    Now serving:
                                    <br>
                                    <br>
                                    <b>Sicilian Pistachio</b>
                                    <br>
                                    Rich Sicilian Pistachios blended into a smooth, creamy gelato with a naturally nutty finish
                                    <br>
                                    <br>

                                    <b>Dark Chocolate & Chocolate Chips</b>
                                    <br>
                                    Velvety dark chocolate gelato made with 70% cacao and finished with crunchy chocolate chips throughout
                                    <br>
                                    <br>
                                    <b>Available for dine-in or takeout</b>
                                    <!-- <br><br> -->
                                    <!-- <b>See you all there!</b><br> -->
                                </h5>
                            </div>
                            <div class="col-lg-1"></div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal">Got it!</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SpecialOverlay',
        data: function() {
            return {
                showModal: false
            }
        },
        methods: {
            closeModal() {
                this.showModal = false;
            }
        }
    }
</script>